import type { FC } from "react";
import { BreadcrumbJsonLd } from "next-seo";
import Head from "next/head";

import { config } from "@/config";

type BreadcrumbItem = {
  position: number;
  name: string;
  item: string;
};

type JsonLdManagerProps = {
  homeConfig?: Record<string, unknown> | unknown;
  structuredData?: readonly Record<string, unknown>[];
  breadcrumbs?: readonly BreadcrumbItem[];
};

const WEBSITE_STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  url: `https://${config.web.domain}`,
  name: "Matic Robots",
};

const JsonLdManager: FC<JsonLdManagerProps> = (props) => {
  const breadCrumbConfig = props.breadcrumbs
    ? [...props.breadcrumbs]
    : undefined;
  const homePageConfig = props.homeConfig;

  return (
    <>
      <Head>
        {homePageConfig !== undefined ? (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(homePageConfig),
            }}
          />
        ) : null}
        <script
          key="matic-website-json-ld"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(WEBSITE_STRUCTURED_DATA),
          }}
        />
        {props.structuredData?.map((entry, index) => (
          <script
            key={`matic-structured-data-${index}`}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(entry) }}
          />
        ))}
      </Head>
      {breadCrumbConfig ? (
        <BreadcrumbJsonLd itemListElements={breadCrumbConfig} />
      ) : null}
    </>
  );
};

export default JsonLdManager;
